{
  "DATA_ASSISTANT": {
    "TITLE": "Assistente Dati",
    "NEW_CONVERSATION": "+ Nuova",
    "LOADING": "Caricamento...",
    "LOADING_MESSAGES": "Caricamento messaggi...",
    "THINKING": "Sto pensando...",
    "UNTITLED": "Conversazione senza titolo",
    "NO_CONVERSATIONS": "Nessuna conversazione. Clicca su \"+ Nuova\" per iniziare.",
    "EMPTY_STATE": "Seleziona una conversazione o creane una nuova per iniziare.",
    "SEND": "Invia",
    "PLACEHOLDER": "Cosa posso scoprire per te?",
    "SHOW_SQL": "Mostra SQL",
    "NO_ROWS": "Nessuna riga restituita.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Elimina conversazione",
    "DELETE_CONFIRM_DESCRIPTION": "Sei sicuro di voler eliminare questa conversazione? Questa azione non può essere annullata.",
    "DELETE_CONFIRM_YES": "Elimina",
    "CHAT": "Chat",
    "REPORTS": "Report",
    "SAVE_TO_REPORT": "Salva nel report",
    "NEW_REPORT": "Nuovo report",
    "REPORT_NAME": "Nome del report",
    "NO_REPORTS": "Nessun report salvato",
    "REPORTS_EMPTY_STATE": "Seleziona un report o creane uno nuovo.",
    "REPORT_SAVED": "Salvato nel report",
    "DELETE_REPORT_CONFIRM": "Elimina report",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Sei sicuro di voler eliminare questo report? Tutti gli elementi salvati saranno rimossi.",
    "DELETE_ITEM_CONFIRM": "Rimuovi elemento",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Sei sicuro di voler rimuovere questo elemento dal report?",
    "EXPORT_CSV": "Esporta CSV",
    "REFRESH": "Aggiorna",
    "QUERY_RUNNING": "Esecuzione query...",
    "QUERY_FAILED": "Query fallita",
    "AUTO_REFRESH": "Aggiornamento automatico",
    "AUTO_REFRESH_NONE": "Manuale",
    "AUTO_REFRESH_30S": "30 secondi",
    "AUTO_REFRESH_1M": "1 minuto",
    "AUTO_REFRESH_5M": "5 minuti",
    "AUTO_REFRESH_10M": "10 minuti",
    "EDIT_MESSAGE": "Modifica messaggio",
    "RENAME_REPORT": "Rinomina report",
    "RENAME_ITEM": "Rinomina elemento",
    "MOVE_UP": "Sposta su",
    "MOVE_DOWN": "Sposta giù",
    "COLLABORATORS": {
      "BUTTON": "Collaboratori",
      "TITLE": "Collaboratori del report",
      "DESCRIPTION": "Scegli quali agenti e team possono visualizzare questo report.",
      "AGENTS": "Agenti",
      "TEAMS": "Team",
      "SELECT_AGENTS": "Seleziona agenti",
      "SELECT_TEAMS": "Seleziona team",
      "SAVE": "Salva",
      "SAVED": "Collaboratori aggiornati",
      "SAVE_FAILED": "Impossibile aggiornare i collaboratori"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Report"
}
